import React from "react";
// import logo from "../assets/img/Aays.png";
import logo from "../../assets/img/Aays.png";
import bgimage from "../../assets/img/AaysImageBG.png";

// import aadiLogo from "../assets/img/aadi-login-logo.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

const Login = () => {
  const { instance } = useMsal(); // Access MSAL instance from context

  const loginBtn = async () => {
    try {
      const loginResponse = await instance.loginPopup(loginRequest); // Trigger login popup
      console.log("Login successful", loginResponse);
    } catch (error) {
      console.error("Login failed", error);
    }
  };

  return (
    <div>
      <div className="Buttons">
        <div className="loginPage">
          <div className="login_body_content">
            <div className="bg-white dark:bg-gray-900 bgColor">
              <div className="login_body_grid">
                <div
                  style={{
                    backgroundImage: `linear-gradient(rgba(187,28,204,0.5), rgba(187, 28, 204,0.4)),url(${bgimage})`,
                  }}
                  className="hidden bg-cover lg:block lg:w-2/3 login_bg_image w-auto"
                >
                  <div style={{textAlign:"center"}} className="login_info">
                    <div>
                      <h2
                        style={{ textTransform: "capitalize" }}
                        className="text-5xl font-bold text-white"
                      >
                        Aays Competitor Analytics Insight Tool
                      </h2>

                      <p className="left_grid_text">
                        Welcome to the Competitor Analytics. Access to this
                        system is limited - <br />
                        please contact &nbsp;
                        <a
                          rel="noreferrer"
                          target={"_blank"}
                          style={{ color: "black" }}
                          href="mailto:sumit.shekhar@aaysinsight.com"
                        >
                          <mark>sumit.shekhar@aaysinsight.com</mark>
                        </a>{" "}
                        for details.
                      </p>
                    </div>
                  </div>
                </div>

                <div style={{textAlign:"center"}} className="right_grid_align bgColor z-10">
                  <div className="flex-1">
                    <div className="text-center">
                      <span className="text-4xl font-bold text-center text-gray-700 dark:text-white MarsLogo">
                        <img width={120} src={logo} alt="img" />
                      </span>

                      <p className="left_grid_text left_margin loginText1 formLableText1">
                        Sign in to access your account
                      </p>
                    </div>

                    <div className="mt-8">
                      <div className="mt-6">
                        <button className="btn_login" onClick={loginBtn}>
                          Sign in
                        </button>
                      </div>
                    </div>

                    <div
                      style={{
                        width: "70%",
                        paddingTop: "1rem",
                        display: "block",
                        margin: "auto",
                      }}
                    >
                      <span
                        id="Login_herf"
                        style={{
                          color: "white",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <a
                          rel="noreferrer"
                          target={"_blank"}
                          className="loginText1 formLableText1"
                          style={{ textDecoration: "none" }}
                          href="mailto:sumit.shekhar@aaysinsight.com?subject=Need Access to the  Lab Analytics - SNOW Queries Applications!"
                        >
                          {" "}
                          Need Access?
                        </a>

                        <a
                          rel="noreferrer"
                          target={"_blank"}
                          className="loginText1 formLableText1"
                          style={{ textDecoration: "none" }}
                          href="mailto:sumit.shekhar@aaysinsight.com?subject=Need Help On Sign in On  Lab Analytics - SNOW Queries Applications!"
                        >
                          {" "}
                          Need Help?
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
